<template>
  <DialogWrapper
    v-if="isPc"
    class="wechat-bind-qrcode-dialog"
    appendToBody
    :title="$t('personal.referrals.rewards.label.weChatQrCodeTip')"
    :show.sync="isShow"
    :close-on-click-modal="false"
    :hideFooter="true"
  >
    <div class="qrcode-wrapper">
      <img class="qrcode-body" :src="qrCodeUrl"/>
      <div class="qrcode-alt"></div>
    </div>
  </DialogWrapper>
  <van-dialog
    v-else
    v-model="isShow"
    class="wechat-bind-qrcode-dialog"
    :overlay-style="{ 'z-index': 9999999999 }"
    :title="$t('personal.referrals.rewards.label.weChatQrCodeTip')"
    :close-on-click-overlay="true"
    :show-confirm-button="false"
    @close="handleClose"
  >
    <div class="qrcode-wrapper">
      <img class="qrcode-body" :src="qrCodeUrl"/>
      <div class="qrcode-alt"></div>
    </div>
  </van-dialog>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
export default {
  components: {
    DialogWrapper
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    isPc: {
      default: false
    },
    companyId: {
      required: true
    }
  },
  data () {
    return {
      qrCodeUrl: null
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },
  created () {
  },
  methods: {
    handleClose () {
      this.$emit('update:show', false)
      this.$emit('close')
    }
  },
  watch: {
    isShow: {
      handler () {
        if (this.isShow) {
          const url = `${location.origin}/django_rest/bind-wechat-account/?company_id=${this.companyId}`
          this.qrCodeUrl = `/django_rest/qr-code/?data=${encodeURIComponent(url)}&company_id=${this.companyId}&include_token=1`
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wechat-bind-qrcode-dialog {
  z-index: 9999999999 !important;
  .qrcode-wrapper {
    text-align: center;
    img {
      width: 300px;
    }
  }
}
</style>
